/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Ui_Import_Summary_New_OtherInputs */

const en_ui_import_summary_new_other = /** @type {(inputs: Ui_Import_Summary_New_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} new sessions`)
};

const de_ui_import_summary_new_other = /** @type {(inputs: Ui_Import_Summary_New_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} neue Einheiten`)
};

/**
* | output |
* | --- |
* | "{count} new sessions" |
*
* @param {Ui_Import_Summary_New_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_import_summary_new_other = /** @type {((inputs: Ui_Import_Summary_New_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Import_Summary_New_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_import_summary_new_other(inputs)
	return de_ui_import_summary_new_other(inputs)
});